// @ts-nocheck
/* eslint-disable */
import Scene from "~/scene";
/**
 * @class Fake poiserver pro pos: vysledky hledani
 * @signal poiparams
 */
SMap.POIServer.Coords = JAK.ClassMaker.makeClass({
	NAME: "SMap.POIServer.Coords",
	VERSION: "1.0",
	EXTEND: SMap.POIServer
});

SMap.POIServer.Coords.prototype.$constructor = function() {
	this.$super("");
	this._sources = ["coor"];
};

/**
 * Zadne POIparams neposilame
 */
SMap.POIServer.Coords.prototype.getPOIParams = function() {
	this._ready = true;
	this._owner.getSignals().makeEvent("poiparams", this);
}

SMap.POIServer.Coords.prototype.getDescription = function(data, meta, callback) {
	var result = {};
	for (var source in data) {
		var ids = data[source];
		for (var i=0;i<ids.length;i++) {
			var id = source + ids[i];
			var arr = ids[i].split(",");
			var coords = Scene.coordsFromWGS84(arr[0], arr[1]);
			result[id] = {
				title: coords.toWGS84(3).reverse().join(" ")
			}
		}
	}

	callback(result);
}

SMap.POIServer.Coords.prototype.getDetail = function(source, id, callback, meta) {
	var arr = id.split(",");
	var coords = Scene.coordsFromWGS84(arr[0], arr[1]);

	var data = {
		status: 200,
		poi: {
			mark: {
				lon: parseFloat(arr[0]),
				lat: parseFloat(arr[1])
			},
			title: coords.toWGS84(3).reverse().join(" ")
		}
	}

	callback(data);
}
